module.exports = __webpack_public_path__ + "static/img/05.d5a342b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/guide/ustd/05.png
// module id = BBju
// module chunks = 1